import { useEffect, useState } from 'react';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';
import { fetchProjects } from '../../DataFetchers/fetchProjects';

const Projects = () => {
  pageTitle('Projects');
  
  const [projectData, setProjectData] = useState([]);

  useEffect(() => {
    fetchProjects().then((data) => {
      setProjectData(data);
    });
  }
  , []);

  return (
    <>
      <HeaderOne></HeaderOne>
      <BreadCrumb title={"Research & Development Projects"}></BreadCrumb>
      <div className="project__page p_relative see__pad">
        <div className="row">
          {projectData.map((item, id) => (
            <div className="col-lg-3 col-md-6 colsm-12" key={id}>
              <div className="portfolio__block p_relative">
                <div className="portfolio__image">
                  <figure>
                    <img alt="" />
                  </figure>
                </div>
                <div className="lower__content p_absolute">
                  <div className="protfolio__text">
                    <div className="text__block">
                      <h4>{item.name}</h4>
                      <p>{item.type}</p>
                    </div>
                    {item.readMore && <div className="protfolio__button">
                      <Link to={`/projects-details?project=${encodeURIComponent(item.name)}`}
                        className="theme-btn theme-btn-one"> Read More<i className="icon-02"></i></Link>
                    </div>}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <FooterOne></FooterOne>
    </>
  );
};

export default Projects;
